// extracted by mini-css-extract-plugin
module.exports = {"nameField":"BeneficiaryCol_nameField__u15-Z","fieldLabel":"BeneficiaryCol_fieldLabel__N7IZ1","fieldValue":"BeneficiaryCol_fieldValue__2xcrX"};